import common from "./es.json";
import { esTranslations as login } from "../../pages/LocalLogin/translations";
import { esTranslations as paymentMethods } from "../../pages/PaymentMethods/translations";
import { esTranslations as dashboard } from "../../pages/Dashboard/translations";
import { esTranslations as invoices } from "../../pages/Invoices/translations";
import { esTranslations as payInvoices } from "../../pages/PayInvoices/translations";
import { esTranslations as invoice } from "../../pages/Invoice/translations";
import { esTranslations as securityDeposit } from "../../pages/SecurityDeposit/translations";

export default {
  common,
  login,
  dashboard,
  paymentMethods,
  invoices,
  payInvoices,
  invoice,
  securityDeposit,
};
